import script from "./maintenance-request-picture-tab.vue?vue&type=script&lang=ts&setup=true"
export * from "./maintenance-request-picture-tab.vue?vue&type=script&lang=ts&setup=true"

import "./maintenance-request-picture-tab.vue?vue&type=style&index=0&id=b0dba86e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0dba86e"]])

export default __exports__